
import { Device } from '../DeviceTypes';

// Function to map smart meter data to Device type
export const mapSmartMetersToDevices = (meters: any[], department: string): Device[] => {
  return meters.map(meter => ({
    id: meter.deviceId,
    name: `${department} Smart Meter ${meter.deviceId}`,
    type: department.toLowerCase(),
    category: 'Smart Meter',
    serial: meter.deviceId,
    status: meter.status === 'Healthy' ? 'active' : meter.status === 'Warning' ? 'maintenance' : 'inactive',
    lastActive: meter.lastCommunication,
    department: department
  }));
};

// Function to map voltage regulators to Device type
export const mapVoltageRegulatorsToDevices = (regulators: any[]): Device[] => {
  return regulators.map(regulator => ({
    id: regulator.deviceId,
    name: `Energy Voltage Regulator ${regulator.deviceId}`,
    type: 'energy',
    category: 'Voltage Regulator',
    serial: regulator.deviceId,
    status: regulator.status === 'Good' ? 'active' : 'maintenance',
    lastActive: regulator.lastCommunication,
    department: 'Energy'
  }));
};
